import dayjs                   from "dayjs";
import { useEffect, useState } from "react";

import { useGetProfileData }                                        from "_common/hooks/auth";
import Toast                                                        from "_common/toast";
import { getGrowthStats, getUserProfile, getUserProfileFromBranch } from "_services/api/user";

import Presentation from "./presentation";

const isSameOrBefore = require ( "dayjs/plugin/isSameOrBefore" );

dayjs.extend ( isSameOrBefore );

const getData = async args => {

	if ( !args?.userId )
		return;

	const { tab, startDate, endDate, userId } = args;

	const { data, average } = await getGrowthStats ( { userId, startDate, endDate, type: tab } );

	return { data, average };
};

const component = () => {

	/*
	* Test date is used for testing the future dates, else it will be the current date
	* prod date is the minimum limit below which the selection/ data fetching is not allowed
	* Todays date is used to set disable future prop in the date picker
	*/
	const todaysDate  = dayjs ();
	const testDate    = todaysDate;// dayjs ( "2022-12-30" );
	const prodDate    = "2022-08-06";
	const userProfile = useGetProfileData ();
	const userId      = userProfile?.id;

	const initialStartDate = dayjs ( testDate ).subtract ( 7, "day" ).isBefore ( prodDate, "day" ) ? dayjs ( prodDate ).format ( "YYYY-MM-DD" ) : dayjs ( testDate ).subtract ( 7, "day" ).format ( "YYYY-MM-DD" );
	const initialEndDate   = dayjs ( testDate ).format ( "YYYY-MM-DD" );

	const [ secondaryUserId, setSecondaryUserId ]   = useState ( userId );
	const [ userLink, setUserLink ]                 = useState ( "" );
	const [ secondaryData, setSecondaryData ]       = useState ( null );
	const [ secondaryProfile, setSecondaryProfile ] = useState ( null );
	const [ average, setAverage ]                   = useState ( null );
	const [ startDate, setStartDate ]               = useState ( initialStartDate );
	const [ endDate, setEndDate ]                   = useState ( initialEndDate );
	const [ tabVal, setTabVal ]                     = useState ( "downloads" );
	const [ secondaryLoading, setSecondaryLoading ] = useState ( false );

	const tab = tabVal;

	useEffect ( () => {
		if ( dayjs ( startDate ).isSameOrBefore ( endDate ) )
			return;
		setEndDate ( dayjs ().format ( "YYYY-MM-DD" ) );
	}, [ startDate ] );

	useEffect ( () => {

		if ( !userLink )
			return;

		async function get_user_id_from_link () {
			const secondary_userid = await getUserIdFromLink ( userLink );

			setSecondaryUserId ( secondary_userid );
		}

		get_user_id_from_link ();
	}, [ userLink ] );

	const getUserIdFromLink = async link => {
		if ( !link ) return;

		const prefixForWeb      = "/profile/";
		const prefixForSingular = "?pcid=";
		const prefixForStream   = "/stream/";

		if ( link.includes ( prefixForStream ) ) {
			Toast.error ( "Please Enter Profile Links only" );
			setSecondaryLoading ( false );
		}
		if ( link.includes ( prefixForWeb ) )
			return link.split ( prefixForWeb )[1].trim ();
		if ( link.includes ( prefixForSingular ) )
			return link.split ( prefixForSingular )[1].trim ();
		if ( link.includes ( "rooter.app.link" ) ) {
			const trimmedLink = link.trim ();
			const response    = await getUserProfileFromBranch ( { url: trimmedLink } );

			return response?.userId;
		}
		if ( isNaN ( link ) ) return "";
		else return link;

	};

	useEffect ( () => {
		const fetchId = secondaryUserId ? secondaryUserId : userId;

		getUserData ( tab, startDate, endDate, fetchId );
	}, [ tabVal, startDate, endDate, userId ] );

	const handleChangeUser = async ( e, startDate, endDate, secondaryUserId ) => {
		e.preventDefault ();
		if ( userLink === "" ) {
			Toast.error ( "Please enter correct Link/ User ID" );

			return;
		}
		if ( isNaN ( userLink ) && userLink.trim ().substring ( 0, 4 ) !== "http" ) {
			Toast.error ( "Please enter correct Link/ User ID" );

			return;

		}
		try {
			await getUserData ( tab, startDate, endDate, secondaryUserId );

			await fetchUserProfile ( secondaryUserId, setSecondaryProfile );

		} catch ( error ) {
			Toast.error ( error.displayMsg );
		}
	};

	async function getUserData ( tab, startDate, endDate, secondaryUserId ) {
		try {
			setSecondaryLoading ( true );
			setSecondaryData ( null );
			const { data: secondaryUserData, average } = await getData ( { tab, startDate, endDate, userId: secondaryUserId } );

			setAverage ( average );
			setSecondaryLoading ( false );

			setSecondaryData ( secondaryUserData );
		} catch ( error ) {
			//
		}
	}

	async function fetchUserProfile ( secondaryUserId ) {

		const secondaryUserProfile = await getUserProfile ( { userId: secondaryUserId } );

		setSecondaryProfile ( secondaryUserProfile );
	}

	return (
		<Presentation
			average          = { average }
			endDate          = { endDate }
			handleChangeUser = { handleChangeUser }
			prodDate         = { prodDate }
			secondaryData    = { secondaryData }
			secondaryLoading = { secondaryLoading }
			secondaryProfile = { secondaryProfile }
			secondaryUserId  = { secondaryUserId }
			setEndDate       = { setEndDate }
			setStartDate     = { setStartDate }
			setTabVal        = { setTabVal }
			setUserLink      = { setUserLink }
			startDate        = { startDate }
			tabVal           = { tabVal }
			testDate         = { testDate }
			todaysDate       = { todaysDate }
			userLink         = { userLink }
			userProfile      = { userProfile }
		/>
	);
};

export default component;

